import { useEffect, useState } from "react";
import { DateTime } from "luxon";
import { Table } from "react-bootstrap";
import { useSessionStore } from "../../../../Stores/SessionStore";

export default function RechargeHistory() {
	const store = useSessionStore();
	const [purchaseHistory, setPurchaseHistory] = useState([]);

	useEffect(() => {
		const getPurchaseHistory = async () => {
			const result = await store.CustomersService.GetPurchaseHistory(store.Session.Customer.Id);
			if (result && result.Success) {
				setPurchaseHistory(Array.isArray(result.Data) ? result.Data.slice(0, 5) : []);
			}
		};

		getPurchaseHistory();
	}, [store]);

	return (
		<div className="portal-dashboard-card">
			<div className="portal-dashboard-card-header">
				<h4>Purchase History</h4>
			</div>
			<div className="portal-dashboard-card-body portal-purchase-history-body">
				<div className="portal-purchase-history-scroll">
					<Table className="portal-purchase-history-table mb-0">
						<thead>
							<tr>
								<th className="portal-purchase-history-date-col">Date</th>
								<th className="portal-purchase-history-package-col">Package</th>
								<th className="portal-purchase-history-amount-col">Amount</th>
								<th className="portal-purchase-history-expiry-col">Expiry Date</th>
								<th className="portal-purchase-history-method-col">Method</th>
							</tr>
						</thead>
						<tbody>
							{purchaseHistory.length > 0 ? (
								purchaseHistory.map((recharge, index) => (
									<tr key={index}>
										<td className="portal-purchase-history-date-col">
											{recharge.Date ? DateTime.fromISO(recharge.Date).toFormat("dd/MM/yyyy") : "—"}
										</td>
										<td className="portal-purchase-history-package-col">{recharge.Package ?? "—"}</td>
										<td className="portal-purchase-history-amount-col">R {recharge.Amount}</td>
										<td className="portal-purchase-history-expiry-col">
											{recharge.ExpiryDate ? DateTime.fromISO(recharge.ExpiryDate).toFormat("dd/MM/yyyy") : "—"}
										</td>
										<td className="portal-purchase-history-method-col">{recharge.Method ?? "—"}</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={5} className="text-center">
										* No Recharges Yet *
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</div>
		</div>
	);
}
